<template>
  <div>
    <div class="flex items-center mt-8">
    </div>
    <!-- BEGIN: Wizard Layout -->
    <div class="intro-y box py-10 sm:py-20 mt-5">
      <div class="flex justify-center">
      </div>
      <div class="px-5 mt-10">
        <div class="font-medium text-center text-lg">Conversion Successful. </div>
        <div class="text-gray-600 text-center mt-2">
          An email will be sent to your nominated email address with the converted file.
        </div>
        <div class="text-gray-600 text-center mt-2">
          Thank you for using PMSTConverter
        </div>
      </div>
    </div>
    <br />
    <div class="text-center">
      <button
          type="button"
          class="button inline-block bg-theme-1 text-white"
          @click="toUserArea"
      >
        Upload another file
      </button>
    </div>
    <!-- END: Wizard Layout -->
  </div>
</template>

<script>
export default {
  methods: {
    async toUserArea() {
      this.$router.push("/user-pdf");
    }
  }
};
</script>
